import { useState } from "react";
import { axios } from "@root/libs/axios";
import { sendErrorLog } from "@root/shared/utils/sendErrorLog";

type ResponseDataType = {
  status: boolean;
  days: number;
  message: string;
};

export const useExtendScoutDeadlineButton = (): {
  handleClickExtendScoutDeadlineButton: (url: string) => void;
} => {
  const [isClicked, setIsClicked] = useState(false);

  const handleClickExtendScoutDeadlineButton = async (url: string) => {
    if (isClicked) return;

    setIsClicked(true);
    document.dispatchEvent(new CustomEvent("track:trackTapScoutConsiderButton", {}));

    try {
      const res = await axios.post<ResponseDataType>(url);
      // アプリケーション側のエラー補足(エラー時は{status: false, message: string}が返ってくる)
      if (!res.data.status) {
        sendErrorLog(new Error(res.data.message || "期限延長に失敗しました"));
        return;
      }
      window.location.reload();
    } catch (error: unknown) {
      sendErrorLog(error instanceof Error ? error : new Error("期限延長に失敗しました"));
    }
  };

  return { handleClickExtendScoutDeadlineButton };
};
